<template>
  <div class="about">
    <h1>This is an about page</h1>



    Click this <VideoBtn 
    button="Video1"
    vidUrl="https://www.youtube.com/embed/91Hys6zTSmY">
    Button 1
    </VideoBtn> to view a video

    <VideoBtn button="button 2">Button 2</VideoBtn>


    <VideoBtn 
    button="button 333"
    vidUrl="https://www.youtube.com/embed/AvPMMQOGnic">
    Button 3
    </VideoBtn>


<div class="main-records-wrapper">

<div class="all-records-wrapper">
  <h1 class="record-title">All-Time Passing Yards</h1>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#fb4f13',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/DEN.svg)' }">
  <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/MAN515097.png"></div>
  <div class="record-name">Peyton Manning</div>
  <div class="record-value">71,940</div>
</div>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#4e2682',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/MIN.svg)' }">
  <div class="record-photo"><img src="http://a.espncdn.com/combiner/i?img=/i/headshots/nfl/players/full/112.png"></div>
  <div class="record-name">Brett Favre</div>
  <div class="record-value">71,838</div>
</div>
<div class="record-wrapper">
  <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/BRE229498.png"></div>
  <div class="record-name">Drew Brees</div>
  <div class="record-value">70,445</div>
</div>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#002344',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/NE.svg)' }">
  <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/BRA371156.png"></div>
  <div class="record-name">Tom Brady</div>
  <div class="record-value">66,159</div>
</div>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#138e97',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/MIA.svg)' }">
  <div class="record-photo"><img src="https://i.pinimg.com/736x/bd/ef/d4/bdefd4eb593c733a1a2aa0f09f9dd72f--dan-marino-miami-dolphins.jpg"></div>
  <div class="record-name">Dan Marino</div>
  <div class="record-value">61,361</div>
</div>

</div>

<div class="all-records-wrapper">
  <h1 class="record-title">All-Time Passes Completed</h1>
  <div class="record-wrapper"
  v-bind:style="{ backgroundColor: '#4e2682',
  backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/MIN.svg)' }">
    <div class="record-photo"><img src="http://a.espncdn.com/combiner/i?img=/i/headshots/nfl/players/full/112.png"></div>
    <div class="record-name">Brett Favre</div>
    <div class="record-value">6,300</div>
  </div>
  <div class="record-wrapper">
    <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/BRE229498.png"></div>
    <div class="record-name">Drew Brees</div>
    <div class="record-value">6,222</div>
  </div>
  <div class="record-wrapper"
  v-bind:style="{ backgroundColor: '#fb4f13',
  backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/DEN.svg)' }">
    <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/MAN515097.png"></div>
    <div class="record-name">Peyton Manning</div>
    <div class="record-value">6,125</div>
  </div>
  <div class="record-wrapper"
  v-bind:style="{ backgroundColor: '#002344',
  backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/NE.svg)' }">
    <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/BRA371156.png"></div>
    <div class="record-name">Tom Brady</div>
    <div class="record-value">5,629</div>
  </div>
  <div class="record-wrapper"
  v-bind:style="{ backgroundColor: '#138e97',
  backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/MIA.svg)' }">
    <div class="record-photo"><img src="https://i.pinimg.com/736x/bd/ef/d4/bdefd4eb593c733a1a2aa0f09f9dd72f--dan-marino-miami-dolphins.jpg"></div>
    <div class="record-name">Dan Marino</div>
    <div class="record-value">4,967</div>
  </div>
</div>

<div class="all-records-wrapper">
  <h1 class="record-title">All-Time Passing TDs</h1>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#fb4f13',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/DEN.svg)' }">
  <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/MAN515097.png"></div>
  <div class="record-name">Peyton Manning</div>
  <div class="record-value">539</div>
</div>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#4e2682',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/MIN.svg)' }">
  <div class="record-photo"><img src="http://a.espncdn.com/combiner/i?img=/i/headshots/nfl/players/full/112.png"></div>
  <div class="record-name">Brett Favre</div>
  <div class="record-value">508</div>
</div>
<div class="record-wrapper">
  <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/BRE229498.png"></div>
  <div class="record-name">Drew Brees</div>
  <div class="record-value">488</div>
</div>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#002344',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/NE.svg)' }">
  <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/BRA371156.png"></div>
  <div class="record-name">Tom Brady</div>
  <div class="record-value">488</div>
</div>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#138e97',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/MIA.svg)' }">
  <div class="record-photo"><img src="https://i.pinimg.com/736x/bd/ef/d4/bdefd4eb593c733a1a2aa0f09f9dd72f--dan-marino-miami-dolphins.jpg"></div>
  <div class="record-name">Dan Marino</div>
  <div class="record-value">420</div>
</div>

</div>

<div class="all-records-wrapper">
  <h1 class="record-title">All-Time Completion %</h1>
  <div class="record-summary">
    Brees broke Sam Bradford's single-season record (71.6) for completion percentage this season at 72 percent, and he now has three of the four most accurate seasons (2011, 71.2, third; 2009, 70.6, fourth).
  </div>
<div class="record-wrapper">
  <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/BRE229498.png"></div>
  <div class="record-name">Drew Brees</div>
  <div class="record-value">66.9%</div>
</div>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#073f2d',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/NYJ.svg)' }">
  <div class="record-photo"><img src="http://a.espncdn.com/combiner/i?img=/i/headshots/nfl/players/full/2149.png"></div>
  <div class="record-name">Chad Pennington</div>
  <div class="record-value">66.0%</div>
</div>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#002344',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/LA.svg)' }">
  <div class="record-photo"><img src="http://a.espncdn.com/i/headshots/nfl/players/65/1682.jpg"></div>
  <div class="record-name">Kurt Warner</div>
  <div class="record-value">65.5%</div>
</div>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#4e2682',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/MIN.svg)' }">
  <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/COU709400.png"></div>
  <div class="record-name">Kirk Cousins</div>
  <div class="record-value">65.5%</div>
</div>
<div class="record-wrapper"
v-bind:style="{ backgroundColor: '#fb4f13',
backgroundImage: 'url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/DEN.svg)' }">
  <div class="record-photo"><img src="http://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/MAN515097.png"></div>
  <div class="record-name">Peyton Manning</div>
  <div class="record-value">65.3%</div>
</div>

</div>


</div>



  </div>
</template>

<script>


import VideoBtn from '@/components/VideoBtn.vue';

export default {
  components: {
    VideoBtn
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    onShowModal(){
      this.showModal = true;
    }
}
}
</script>

<style scoped>

.main-records-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    background-color:#fff;
}

.all-records-wrapper {
    display: flex;
    flex-wrap:wrap;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
    background: white;
    width: 45%;
    box-shadow: 0px 0px 33px 0px black;
    padding: 30px 0px;
}

.record-wrapper {
  display:flex;
  justify-content: space-between;
  align-items: center;
  background-color: #D3BC8D;
   background-image: url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/NO.svg);
  height: 75px;
  width: 100%;
  max-width:900px;
  font-family: 'Teko', sans-serif;
  font-size: 30px;
  text-transform: uppercase;
  background-repeat: no-repeat;
  background-position: -8px center;
  background-size: 250px;
  box-shadow: inset 0px -3px 10px -3px black;
  color:#fff;
}

.record-title {
      font-family: 'Teko', sans-serif;
    font-size: 50px;
    text-transform: uppercase;
    margin: 0px;
}

.record-photo {
  align-self:center;
  height:100%;
  width: 25%;
  text-align: left;
}
.record-photo > img {
  height:100%;
  align-self:center;
}
.record-name {
    font-size: 70px;
    line-height: 75px;
    position: relative;
    top: 7px;
    width: 50%;
  text-align: left;

}
.record-value {
font-size: 60px;
    line-height: 68px;
    position: relative;
    top: 0px;
    width: 17%;
    background: #0000005e;
    border-radius: 12px;
    height: 59px;
    border-top-left-radius: 0px;
    border-bottom-right-radius: 0px;
    margin-right: 5px;
    box-shadow: -3px 0px 0px 2px #00000085;
}

.record-summary {
    font-family: 'Teko', sans-serif;
    font-weight: 300;
    font-size: 32px;
    line-height: 43px;
    padding: 10px 10px;
}

.record-wrapper:first-of-type {
    border-top-right-radius: 19px;

}

.record-wrapper:last-of-type {

    border-bottom-left-radius: 19px;
}

@media (max-width: 1825px) {
.all-records-wrapper {
    width: 100%;
}

}


@media (max-width: 900px) {
.record-wrapper {
  height: 50px;
  background-position: -65px center;
}

.record-name {
    font-size: 54px;
    line-height: 45px;
    position: relative;
    top: 6px;
}
.record-value {
    font-size: 30px;
    line-height: 42px;
    position: relative;
    top: 0px;
    height: 38px;
}

.record-summary {
    font-size: 18px;
    line-height: 20px;
    padding: 10px 10px;
}

}

@media (max-width: 620px) {
  .record-wrapper {
    height: 50px;
    background-position: -49px center;
    background-size: 150px;
}

  .record-name {
    font-size: 35px;
    line-height: 35px;
    position: relative;
    top: 4px;
}
.record-title {
    font-size: 20px;

}
}

@media (max-width: 375px) {

.record-name {
    font-size: 26px;
    line-height: 24px;
    position: relative;
    top: 3px;
}
}

</style>


// WEBPACK FOOTER //
// src/views/Records2.vue